<template>
  <div id="assessed-values" class="mb-3">
    <div class="table-responsive">
      <table class="table table-sm table-hover table-bordered mb-1">
        <tbody>
          <tr v-if="!items.length">
            <td colspan="2" class="text-center text-muted p-3">
              No data
            </td>
          </tr>
          <tr v-for="(item, index) in items" v-bind:key="index">
            <td>{{ item.Description }}</td>
            <td class="text-end">{{ item.Amount | currency(false) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="text-end d-print-none">
      <button
        type="button"
        @click="loadCircuitBreakerData"
        class="btn btn-primary btn-sm text-white shadow"
        data-bs-toggle="modal"
        data-bs-target="#circuit-breaker-modal"
      >
        Circuit Breaker
      </button>
    </div>

    <div
      class="modal fade"
      ref="cbmodal"
      id="circuit-breaker-modal"
      tabindex="-1"
      aria-labelledby="circuit-breaker-modal-label"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="circuit-breaker-modal-label">
              Circuit Breaker Allocations
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div v-if="loading" class="m-5 p-5 text-center">
              Loading data...
            </div>

            <div v-if="!loading" class="table-responsive">
              <table
                class="table table-sm table-striped table-hover table-borderless ledger"
              >
                <thead>
                  <tr class="border-bottom">
                    <th scope="col">&nbsp;</th>
                    <th scope="col" class="text-end">Land</th>
                    <th scope="col" class="text-end">Improvement</th>
                    <th scope="col" class="text-end">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">Homestead: 1%</th>
                    <td class="text-end">
                      {{ cba.Homestead_Land | currency(false) }}
                    </td>
                    <td class="text-end">
                      {{ cba.Homestead_Improvement | currency(false) }}
                    </td>
                    <td class="text-end">
                      {{ cba.Homestead_Total | currency(false) }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Residential: 2%</th>
                    <td class="text-end">
                      {{ cba.Residential_Land | currency(false) }}
                    </td>
                    <td class="text-end">
                      {{ cba.Residential_Improvement | currency(false) }}
                    </td>
                    <td class="text-end">
                      {{ cba.Residential_Total | currency(false) }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Non-Residential: 3%</th>
                    <td class="text-end">
                      {{ cba.NonResidential_Land | currency(false) }}
                    </td>
                    <td class="text-end">
                      {{ cba.NonResidential_Improvement | currency(false) }}
                    </td>
                    <td class="text-end">
                      {{ cba.NonResidential_Total | currency(false) }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Long Term Care: 2%</th>
                    <td class="text-end">
                      {{ cba.LongTerm_Land | currency(false) }}
                    </td>
                    <td class="text-end">
                      {{ cba.LongTerm_Improvement | currency(false) }}
                    </td>
                    <td class="text-end">
                      {{ cba.LongTerm_Total | currency(false) }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Ag. Non-Res: 2%</th>
                    <td class="text-end">
                      {{ cba.AGNonRes_Land | currency(false) }}
                    </td>
                    <td class="text-end">
                      {{ cba.AGNonRes_Improvement | currency(false) }}
                    </td>
                    <td class="text-end">
                      {{ cba.AGNonRes_Total | currency(false) }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Apartment: 2%</th>
                    <td class="text-end">
                      {{ cba.Apartment_Land | currency(false) }}
                    </td>
                    <td class="text-end">
                      {{ cba.Apartment_Improvement | currency(false) }}
                    </td>
                    <td class="text-end">
                      {{ cba.Apartment_Total | currency(false) }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Mobile: 2%</th>
                    <td class="text-end">
                      {{ cba.Mobile_Land | currency(false) }}
                    </td>
                    <td class="text-end">&nbsp;</td>
                    <td class="text-end">
                      {{ cba.Mobile_Total | currency(false) }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Total:</th>
                    <td class="text-end">
                      {{ cba.Total_Land | currency(false) }}
                    </td>
                    <td class="text-end">
                      {{ cba.Total_Improvement | currency(false) }}
                    </td>
                    <td class="text-end">{{ cba.Total | currency(false) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cba: {},
      loading: true,
    };
  },
  methods: {
    loadCircuitBreakerData() {
      this.loading = true;
      this.axios
        .get(process.env.VUE_APP_DATASERVICE + "GetCircuitBreakerAllocations", {
          params: {
            CorpCode: this.county.corpCode.toUpperCase(),
            dup: this.$route.params.dup,
            PayYear: this.$route.params.payYear,
          },
        })
        .then((response) => {
          this.cba = response.data || {};
          this.loading = false;
        });
    },
  },
  props: {
    county: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>
